export default __webpack_public_path__ + "static/media/cat_gemeente.3568aa0b.svg";